import { IconButton, IconButtonSize } from "shared/components/IconButton";
import { XClose } from "untitledui-js-base";

export const Header = ({
  title,
  description,
  onClose
}: {
  title: string;
  description: string;
  onClose: () => void;
}) => {
  return (
    <div className="p-6 border-b border-alpha-40 relative">
      <h1 className="text-xl font-bold text-content-1000 mb-2">{title}</h1>
      <p className="text-sm text-content-400">{description}</p>
      <IconButton
        Icon={XClose}
        size={IconButtonSize.SM}
        borderLess
        className="absolute top-4 right-4"
        onClick={onClose}
      />
    </div>
  );
};
